import React from "react";
import { TextField, Loading, File } from "components/form";
import { required, validationWrapper } from "lib/formValidations";
import { Formik, Field, Form } from "formik";
import { useGallery } from "store/gallery";
import { TextArea } from "components/form";
import config from "config";

export default function Edit(props) {
  const {
    submittUpdateFile,
    dispatch,
    current_collection,
    getCollections,
  } = useGallery();

  return (
    <div className="flex flex-col w-full pt-3 px-4 md:px-16 h-full">
      {/* Header Section */}
      <div className="flex w-full justify-between items-center h-16 mb-6 bg-gray-100 px-6 py-4 rounded shadow-md">
        <h2 className="text-xl font-bold text-gray-800">
          ویرایش فایل {props.item.translations.fa.title}
        </h2>
        <button
          type="button"
          onClick={props.handleBack}
          className="bg-red-500 text-white px-4 py-2 rounded shadow hover:bg-red-600 transition"
        >
          <span>بازگشت</span>
        </button>
      </div>

      {/* Form Section */}
      <Formik
        initialValues={props.item}
        onSubmit={async (values, { setSubmitting }) => {
          await dispatch(
            submittUpdateFile({ ...values }, () => {
              props.handleBack();
              dispatch(getCollections());
            })
          );
          setSubmitting(false);
        }}
      >
        {({ isSubmitting, setFieldValue }) => (
          <Form className="flex-grow overflow-y-auto bg-gray-50 rounded shadow-md p-4 h-[70vh]">
            <div className="flex flex-col md:flex-row w-full gap-4">
              {/* File Upload Section */}
              <div className="w-full md:w-6/12 space-y-6 bg-white p-4 md:p-6 rounded shadow-md ">
                <h3 className="text-lg font-bold text-gray-700">
                  بارگذاری فایل‌ها
                </h3>

                {/* Image Field */}
                <div className="flex flex-col space-y-2">
                  <label className="text-sm font-bold text-gray-700 flex items-center gap-2">
                    📷 تصویر
                  </label>
                  {props.item.image && (
                    <img
                      className="w-full h-auto gallery-image-item rounded"
                      src={`${process.env.REACT_APP_MEDIA_BASE_URL}${props.item.image.url}`}
                      alt="Image"
                    />
                  )}
                  <Field
                    name="image"
                    component={File}
                    type="file"
                    setFieldValue={setFieldValue}
                    accept="image/*"
                    className="h-10 px-3 border rounded"
                  />
                  <p className="text-xs text-gray-500">
                    فقط فرمت‌های تصویری مجاز هستند (jpg, png, gif و ...)
                  </p>
                </div>

                {/* Video Field */}
                <div className="flex flex-col space-y-2">
                  <label className="text-sm font-bold text-gray-700 flex items-center gap-2">
                    🎥 ویدیو
                  </label>
                  {props.item.video && (
                    <video
                      className="w-full h-auto rounded"
                      controls
                      src={props.item.video.url}
                    >
                      Your browser does not support the video tag.
                    </video>
                  )}
                  <Field
                    name="video"
                    component={File}
                    type="file"
                    setFieldValue={setFieldValue}
                    accept="video/*"
                    className="h-10 px-3 border rounded"
                  />
                  <p className="text-xs text-gray-500">
                    فقط فرمت‌های ویدیویی مجاز هستند (mp4, avi, mkv و ...)
                  </p>
                </div>

                {/* Audio Field */}
                <div className="flex flex-col space-y-2">
                  <label className="text-sm font-bold text-gray-700 flex items-center gap-2">
                    🎵 صوت
                  </label>
                  {props.item.audio && (
                    <audio className="w-full" controls>
                      <source src={props.item.audio.url} />
                      Your browser does not support the audio tag.
                    </audio>
                  )}
                  <Field
                    name="audio"
                    component={File}
                    type="file"
                    setFieldValue={setFieldValue}
                    accept="audio/*"
                    className="h-10 px-3 border rounded"
                  />
                  <p className="text-xs text-gray-500">
                    فقط فرمت‌های صوتی مجاز هستند (mp3, wav و ...)
                  </p>
                </div>
              </div>

              {/* Information Section */}
              <div className="w-full md:w-5/12 space-y-6 bg-white p-4 md:p-6 rounded shadow-md ">
                <h3 className="text-lg font-bold text-gray-700">
                  اطلاعات فایل
                </h3>
                <Field
                  label="عنوان فارسی"
                  name="translations.fa.title"
                  component={TextField}
                />
                <Field
                  label="توضیح فارسی"
                  name="translations.fa.summary"
                  component={TextArea}
                />
                <Field
                  label="عنوان انگلیسی"
                  name="translations.en.title"
                  component={TextField}
                />
                <Field
                  label="توضیح انگلیسی"
                  name="translations.en.summary"
                  component={TextArea}
                />
                <Field
                  label="نوع"
                  name="type"
                  component={TextField}
                  className="h-10 px-3 border rounded"
                />
                <Field
                  label="اسلاگ استریم"
                  name="streamSlug"
                  component={TextField}
                  className="h-10 px-3 border rounded"
                />
                <div className="intro-y">
                  <span>تایم استریم:</span>
                  <Field
                    name="streamDuration"
                    component={TextField}
                    className="h-10 px-3 border rounded"
                  />
                </div>
              </div>
            </div>

            {/* Submit Button */}
            <div className="w-full flex justify-center mt-4 md:mt-8">
              <button
                className="rounded bg-green-500 text-white px-8 py-3 font-bold shadow hover:bg-green-600 transition"
                type="submit"
                disabled={isSubmitting}
              >
                {isSubmitting ? <Loading /> : "آپلود"}
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
}
